import React from "react";
import { Link } from "react-router-dom";

const ChildFuture = () => {
  return (
    <section className='z-1 overflow-hidden'>
      <div className='container'>
        <div>
          <div className='d-flex justify-content-between mb-60 align-items-center flex-wrap gap-20'>
            <div>
              <div
                className='fw-semibold text-main-800 text-xl d-flex align-content-center gap-8 mb-16 flex-wrap'
                data-aos='fade-down'
              >
                <span>
                  <i className='ph-bold ph-graduation-cap' />
                </span>
                <span>Solusi Penelitian Akademik</span>
              </div>
              <h2 className='fw-semibold heading-three text-neutral-700 mb-2 wow bounceIn'>
                Layanan Penelitian Akademik
              </h2>
            </div>
          </div>
          <div className='pt-30'>
            <div className='row gy-4'>
              <div className='col-lg-4 col-md-6' data-aos='fade-up' data-aos-duration={700}>
                <div className='service-card p-4 rounded-3 h-100'>
                  <div className='icon-wrapper mb-4'>
                    <i className='ph-bold ph-article text-main-600 fs-1'></i>
                  </div>
                  <h4 className='mb-3'>Penulisan Jurnal Terakreditasi SINTA 1-6</h4>
                  <p className='text-neutral-700'>
                    Kami menawarkan layanan penulisan jurnal akademik sesuai dengan standar akreditasi SINTA 1 hingga SINTA 6, membantu Anda mempublikasikan karya ilmiah di jurnal bereputasi di Indonesia.
                  </p>
                  <Link to='/services/sinta' className='btn btn-link text-main-600 p-0 mt-3'>
                    Selengkapnya <i className='ph-bold ph-arrow-right'></i>
                  </Link>
                </div>
              </div>

              <div className='col-lg-4 col-md-6' data-aos='fade-up' data-aos-duration={700}>
                <div className='service-card p-4 rounded-3 h-100'>
                  <div className='icon-wrapper mb-4'>
                    <i className='ph-bold ph-globe text-main-600 fs-1'></i>
                  </div>
                  <h4 className='mb-3'>Penulisan Jurnal Internasional (Scopus, WoS)</h4>
                  <p className='text-neutral-700'>
                    Layanan penulisan untuk publikasi di jurnal internasional bereputasi, termasuk jurnal yang terindeks Scopus dan Web of Science.
                  </p>
                  <Link to='/services/international' className='btn btn-link text-main-600 p-0 mt-3'>
                    Selengkapnya <i className='ph-bold ph-arrow-right'></i>
                  </Link>
                </div>
              </div>

              <div className='col-lg-4 col-md-6' data-aos='fade-up' data-aos-duration={700}>
                <div className='service-card p-4 rounded-3 h-100'>
                  <div className='icon-wrapper mb-4'>
                    <i className='ph-bold ph-books text-main-600 fs-1'></i>
                  </div>
                  <h4 className='mb-3'>Pengerjaan Skripsi, Tesis, dan Disertasi</h4>
                  <p className='text-neutral-700'>
                    Kami menyediakan layanan penulisan dan revisi skripsi, tesis, dan disertasi dengan perhatian penuh terhadap detail akademik sesuai dengan pedoman dan persyaratan universitas Anda.
                  </p>
                  <Link to='/services/thesis' className='btn btn-link text-main-600 p-0 mt-3'>
                    Selengkapnya <i className='ph-bold ph-arrow-right'></i>
                  </Link>
                </div>
              </div>

              <div className='col-lg-4 col-md-6' data-aos='fade-up' data-aos-duration={700}>
                <div className='service-card p-4 rounded-3 h-100'>
                  <div className='icon-wrapper mb-4'>
                    <i className='ph-bold ph-clipboard-text text-main-600 fs-1'></i>
                  </div>
                  <h4 className='mb-3'>Konsultasi Topik dan Metodologi</h4>
                  <p className='text-neutral-700'>
                    Kami membantu Anda memilih topik riset yang tepat dan metodologi yang sesuai untuk memastikan hasil penelitian yang valid dan bermanfaat.
                  </p>
                  <Link to='/services/consultation' className='btn btn-link text-main-600 p-0 mt-3'>
                    Selengkapnya <i className='ph-bold ph-arrow-right'></i>
                  </Link>
                </div>
              </div>

              <div className='col-lg-4 col-md-6' data-aos='fade-up' data-aos-duration={700}>
                <div className='service-card p-4 rounded-3 h-100'>
                  <div className='icon-wrapper mb-4'>
                    <i className='ph-bold ph-database text-main-600 fs-1'></i>
                  </div>
                  <h4 className='mb-3'>Pengambilan Data Dalam Negeri dan Luar Negeri</h4>
                  <p className='text-neutral-700'>
                    Layanan pengambilan data riset yang mencakup berbagai wilayah, baik di dalam negeri maupun luar negeri, untuk kebutuhan riset yang lebih luas dan komprehensif.
                  </p>
                  <Link to='/services/data-collection' className='btn btn-link text-main-600 p-0 mt-3'>
                    Selengkapnya <i className='ph-bold ph-arrow-right'></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChildFuture;
